"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.cookieNameEnum = exports.eventTypes = void 0;
// scout 支持的事件类型枚举
var eventTypes = ['moduleClick', 'moduleView', 'pageView', 'request', 'fetch_duration', 'page_open']; // 属性和cookie名枚举

exports.eventTypes = eventTypes;
var cookieNameEnum = {
  deviceId: 'device_id',
  biDeviceId: 'bi_device_id',
  version: 'version',
  // NOTE 来分期项目默认的是 UNI_IDENTIFY_TAG_NEW
  userid: 'user_id',
  // NOTE 来分期项目默认的是 lfq_uniq_uuid
  useridNum: 'user_id',
  channelFrom: 'lfqChannelFrom',
  did: 'did',
  fromApp: 'fromApp',
  sprc: 'LFQ-SPR-C'
};
exports.cookieNameEnum = cookieNameEnum;
var _default = {
  eventTypes: eventTypes,
  cookieNameEnum: cookieNameEnum
};
exports["default"] = _default;